import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';
export const vatFactorSchema = baseObjectSchema.extend({
  id: z.string(),
  name: z.string().optional(),
  code: z.string().optional(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  vatCategoryId: z.string(),
  vatLevelId: z.string(),
  vatFactorValue: z.number(),
  vatCategory: baseSchema.optional(),
  vatLevel: baseSchema.optional(),
});

export const getVatFactorsSchema = z.array(vatFactorSchema);

export type GetVatFactorsResponse = z.infer<typeof getVatFactorsSchema>;
